import React from 'react';
import { MujiLink } from '@souche-f2e/muji';
import { withRouter, connect } from '@souche-f2e/muji';
import { Icon, Modal, TreeSelect, Spin, Steps } from 'antd';
import { dispatch } from '@@/store';

@withRouter
class DocPage extends React.Component {
  constructor() {
    super();
    this.state = {
      exportVisiable: false,
      selectVaule: [],
      step: 0,
      host: process.env.MUJI_APP_HOST ? `http://${process.env.MUJI_APP_HOST}` : window.location.origin
    };
  }
  handleSubmit = () => {
    const step = this.state.step;
    let exportVisiable = true;
    if (step === 0) {
      const submitList = this.state.selectVaule.reduce((list, curr) => {
        return list.concat(curr.split('-')[0].split(','));
      }, []);
      const submitSet = new Set(submitList);
      dispatch.pdf.generatePdf([...submitSet].join(','));
    } else if (step === 1) {
      const { pdfUrl } = this.props.pdf;
      if (pdfUrl) {
        window.open(`${this.state.host}/portal/api/v2/pdf/download/${pdfUrl}`)
      } else {
        return;
      }
    } else {
      dispatch.pdf.updatePath({
        pdfUrl: ''
      })
      exportVisiable = false;
    }
    this.setState({
      step: (step + 1) % 3,
      exportVisiable: exportVisiable
    })

  }
  render() {
    const onExportClick = () => {
      this.setState({
        exportVisiable: !this.state.exportVisiable
      });

    };
    const { groupMap, groups } = this.props.sider;
    const onChange = selectVaule => {
      this.setState({ selectVaule });
    };
    let treeData = [];
    if (Object.keys(groupMap).length) {
      treeData = Object.entries(groupMap).map(([key, elem]) => {
        let ids = [];
        const children = elem.map(elem => {
          ids.push(elem.key);
          return {
            title: elem.name,
            value: `${elem.key}-${key}`,
            key: `${elem.key}-${key}`,
          }
        });
        return {
          title: groups.filter((elem) => elem.key === key)[0].name,
          key,
          value: `${ids}-group`,
          children
        }
      });
    }

    const tProps = {
      treeData,
      value: this.state.selectVaule,
      onChange: onChange,
      treeCheckable: true,
      showCheckedStrategy: TreeSelect.SHOW_PARENT,
      searchPlaceholder: 'Please select',
      style: {
        width: '100%',
      },
    };
    const stepButtonTextList = [
      '确认', ['等待', '下载'], '完成'
    ];
    let stepButtonText = this.state.step !== 1 ? stepButtonTextList[this.state.step] : stepButtonTextList[this.state.step][this.props.pdf.pdfUrl ? 1 : 0];

    const modalItem = (() => {
      if (this.state.step === 0) {
        return <TreeSelect {...tProps} />
      } else if (this.state.step === 1) {
        const { pdfUrl } = this.props.pdf;
        if (!pdfUrl) {
          return <Spin />
        } else {
          return <div style={{ width: "100%" }}>
            <a align={"center"} onClick={() => {
              window.open(`${this.state.host}/portal/api/v2/pdf/download/${pdfUrl}`)
            }}>
              <p>下载生成的 PDF 文档</p>
            </a>
          </div>
        }
      } else {
        return <p style={{ margin: "0 auto", align: "center", width: "100%" }} align={"center"}>下载成功!</p>
      }
    })();

    return (
      <div>
        <p>
          本文档为 <strong>预发 / 生产文档</strong>，如需查看 <strong>测试 / Stable 文档</strong>，请点击 <MujiLink to="/documents/stable_docs">测试 / Stable 文档</MujiLink></p>
        <br />
        <p>请在左侧菜单栏选择需要查看的 API 文档</p>
        <br />
        <p>接入指南请参考 <a style={{ color: '#1890ff' }} href="#/documents/docking_process">对接流程</a></p>
        <br />
        <p style={{ color: '#1890ff', cursor: 'pointer' }} onClick={onExportClick} ><Icon type="download" /> 导出 PDF 文档</p>
        <Modal
          title="选择导出文档"
          visible={this.state.exportVisiable}
          onOk={this.handleSubmit}
          onCancel={onExportClick}
          okText={stepButtonText}
          okButtonProps={this.state.step === 1 && !this.props.pdf.pdfUrl ? { disabled: true } : {}}
          cancelText='退出'
          maskClosable={false}
        >
          <Steps size="small" current={this.state.step} >
            <Steps.Step title="选择文档" />
            <Steps.Step title="等待生成" />
            <Steps.Step title="下载" />
          </Steps>
          <div style={{ height: "150px", margin: "50px 0 0 0" }}>
            {modalItem}
          </div>

        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    sider: state.sider,
    pdf: state.pdf
  }
};

export default connect(mapStateToProps)(DocPage);
